import React from "react";
import { withStyles } from "@mui/styles";
import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { useStyles } from "../indexFormStyles";

function BackdropLoader({ backdrop = false }) {
  return (
    <Backdrop sx={{ color: "#fff", zIndex: 1301 }} open={backdrop}>
      <Box
        flexDirection="column"
        display="flex"
        justifyContent="center"
        sx={{ width: "100%" }}
        textAlign="center"
      >
        <Typography variant="body1">
          Processing request, please wait.
        </Typography>
        <Box mt={2}>
          <CircularProgress color="inherit" />
        </Box>
      </Box>
    </Backdrop>
  );
}

export default withStyles(useStyles, { withTheme: true })(BackdropLoader);
